import { defaultEventFilters, EventListRequestParams } from "../forms/filters/event";
import { BoolResponce, CustomerDisplayData, EventCardInfo, EventData, EventFullData, EventType } from "../types";
import BackendConnect from "./connect";

export interface EventDataToSave {
    responsible_id: number;
    customer_id: number;
    name?: string;
    description?: string;
    deadline?: string;
    type_id: number;
    value: number;
}

export interface EventCreationData {
  customer_id: number;
  date_end?: number;
  type_id?: number;
  responsible_id?: number;
  comment?: string;
  transfer_customer?: boolean;
}

export interface AddUserRequestParams {
  eventid: number; 
  participantid: number; 
  statusid: number;
}

export class BackendEventService extends BackendConnect {
  protected static instance: BackendEventService;

  constructor(headers: Record<string, string>) {
    super(headers);
  }

  static getInstance(): BackendEventService {
    if (!BackendEventService.instance) {
      BackendEventService.instance = new BackendEventService({});
      const bearerToken = localStorage.getItem("bearerToken");
      if (bearerToken) {
        BackendEventService.instance.setAccessToken(bearerToken);
      }
    }
    return BackendEventService.instance;
  }

  public async getActiveEventTypes(): Promise<{ types: EventType[]}> {
    return this.get("/events/gettypes");     
  }

  public async getAllEvents(params: EventListRequestParams = defaultEventFilters): Promise<{ events: EventData[] }> {
    return this.get("/events/getall", {...params});
  }

  public async getAllEventsCount(params: EventListRequestParams = defaultEventFilters): Promise<{ count: number }> {
    return this.get("/events/getallcount", {...params});
  }

  public async addUserToEvent (params: AddUserRequestParams): Promise<BoolResponce | null> {
    return this.post("/events/adduser", {...params}, "POST");
  }

  public async deleteUserFromEvent (params: AddUserRequestParams): Promise<BoolResponce | null> {
    return this.post("/events/deleteuser", {...params}, "POST");
  }

  public async getEventCards(userid: number, params: EventListRequestParams): Promise<{ events: EventCardInfo[]}> {
    return this.get(`/events/cards/${userid}`, {...params})
  }

  public async getEventFullData (eventid: number): Promise<{event: EventFullData} | null> {
    return this.get(`/event/fulldata/${eventid}`)
  }

  public async createEvent(data: EventCreationData): Promise<{
    success: boolean,
    is_transfer?: boolean,
    newCustomerData?: CustomerDisplayData
  }> {
    return this.post("/events/create", data, "POST")
  }

  public async updateEvent(data: { event_id: number, status_id?: number, date_end?: number; comment: string }): Promise<{success: boolean}> {
    return this.post(`/events/update/${data.event_id}`, data, "POST")
  }
}

export const eventBackend = BackendEventService.getInstance();
